module.exports = __webpack_public_path__ + "static/img/10.31c0b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/10.png
// module id = MvA3
// module chunks = 0